import { operatorClient } from 'domain/HttpClients';

/**
 *
 * @param from
 * @param to
 * @param status
 * @param headers
 * @returns {*}
 */
export const fetchStatements = (filters) => operatorClient
  .Get('/api/reconciliation')
  .withParams(filters)
  .send();

/**
 *
 * @param refId
 * @param headers
 * @returns {*}
 */
export const download = (params) => operatorClient
  .Get('/api/reconciliation/by-ref-id/download')
  .withParams(params)
  .send();

/**
 *
 * @param refId
 * @param trxId
 * @param headers
 * @returns {*}
 */
export const markAsPaid = (params, headers) => operatorClient
  .Post('/api/reconciliation/ref-id/markpaid')
  .withData(params)
  .send();
